export const getters = {
  CLIENT_DETAILS: (state: any) => state.clientDetails,
  LABELS: (state: any) => state.labels
}
